import * as React from "react";
import { FaSlidersH} from "react-icons/fa";
import {Dropdown, DropdownButton} from "react-bootstrap";
import {Link} from "react-router-dom";
import {routes} from "./Routes";
import {useEmployeeMenuConfig} from "../queries";
import {useMemo} from "react";

export type AdminMenuDropdownProps = {
    icon: React.ReactNode;
    routes: typeof routes[number]['routes'];
};

export const AdminMenuDropdown = (props: AdminMenuDropdownProps) => {
    const { icon, routes } = props;
    
    const { data: employeeMenuConfig } = useEmployeeMenuConfig();

    const allowedMenuIdSet = useMemo(
        () =>
            employeeMenuConfig
                ? new Set(employeeMenuConfig?.map(employeeMenuConfig => employeeMenuConfig.menu_id))
                : undefined,
        [employeeMenuConfig]
    );

    const displayRoutes = useMemo(
        () => routes.filter(route =>
            allowedMenuIdSet?.has(route.menuId)
        ),
        [routes, allowedMenuIdSet]
    );
    
    if (displayRoutes.length === 0) {
        return null;
    }
    
    return (
        <DropdownButton
            id="dropdown-basic-button"
            title={icon}
            variant="outline-dark"
            size="sm"
        >
            {displayRoutes.map(route => (
                <Dropdown.Item key={route.menuId}>
                    <Link to={route.pathname}>{route.menuName}</Link>
                </Dropdown.Item>
            ))}
        </DropdownButton>
    );
};